import { render, staticRenderFns } from "./adminMobileTransfer.vue?vue&type=template&id=349d1285&scoped=true"
import script from "./adminMobileTransfer.vue?vue&type=script&lang=js"
export * from "./adminMobileTransfer.vue?vue&type=script&lang=js"
import style0 from "./adminMobileTransfer.vue?vue&type=style&index=0&id=349d1285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349d1285",
  null
  
)

export default component.exports